<template>
  <div>
    <div class="arrWrap">
      <div
        style="
          width: 100%;
          float: left;
          padding: 15px 15px;
          box-sizing: border-box;
        "
      >
        <div class="addcalss" @click="addbtn()">
          <i
            :class="
              !addType
                ? 'el-icon-circle-plus-outline'
                : 'el-icon-remove-outline'
            "
          ></i>
          {{ !showType ? "添加地址" : "修改地址" }}
        </div>
      </div>
      <el-collapse-transition>
        <div
          class="coutn_show"
          v-show="addType"
          style="width: 100%; float: left"
        >
          <div style="padding: 15px; border: 1px solid #33">
            <div class="Iteminput">
              <div style="min-width: 60px">联系人</div>
              <div style="width:100%">
                <el-input
                  :maxlength="10"
                  :show-word-limit="true"
                  clearable
                  style="width:100%"
                  v-model="form.name"
                ></el-input>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">联系方式</div>
              <div style="width:100%">
                <el-input
                  :maxlength="13"
                  clearable
                 style="width:100%"
                  v-model="form.tel"
                ></el-input>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">联系地址</div>
              <div style="width:100%">
                <el-cascader
                 style="width:100%"
                  v-model="shouaddressid"
                  :options="countLIst"
                  :props="defaultParams"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">详细地址</div>
              <div style="width:100%">
                <el-input
                style="width:100%"
                  v-model="form.address"
                ></el-input>
              </div>
            </div>
          </div>
          <div style="width: 100%; height: 50px;text-align: center;">
            <el-button
              v-show="!showType"
              type="primary"
              @click="back('I')"
              >确定</el-button
            >
            <el-button
              v-show="showType"
              type="primary"
              @click="back('U')"
              >修改</el-button
            >
            <el-button
              type="success"
              @click="quxiao"
              >取消</el-button
            >
          </div>
        </div>
      </el-collapse-transition>

      <div style="width: 100%; float: left" v-show="!addType">
        <el-table
          height="400"
          tooltip-effect="dark"
          :data="
            tableData.filter(
              (data) =>
                !search ||
                data.name.toLowerCase().includes(search.toLowerCase())
            )
          "
          highlight-current-row
          border
          ref="Table"
          style="width: 100%;cursor:pointer"
          @row-click='getCurrentRow'
        >
          <!-- <el-table-column label="选择" width="65">
            <template slot-scope="scope">
              <el-checkbox
                :label="scope.$index"
                v-model="scope.row.changeType"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;
              </el-checkbox>
            </template>
          </el-table-column> -->
          <el-table-column label="姓名" width="100" align="center" prop="name">
          </el-table-column>
          <el-table-column label="电话" width="120" align="center" prop="tel">
          </el-table-column>
          <el-table-column
            label="联系地址"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.parvince }}
              {{ scope.row.city }}
              {{ scope.row.area }}
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="160">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="请输入姓名"/>
            </template>
            <template slot-scope="scope">
              <!-- <el-button type="text" size="mini" @click="setMome(scope.row)">
                <span
                  :style="
                    scope.row.isdefault ? 'color:#604AFF' : 'color:#9A9A9A'
                  "
                  >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
                >
              </el-button> -->
              <el-button
                size="mini"
                type="text"
                @click.stop="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click.stop="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    contactype2: {
      type: String,
    },
    tableData: {
      type: Array,
    },
    SonshowType:{
      type:Boolean
    }
  },
  data() {
    return {
      showType: false,
      setLIstdata: [],
      shouaddressid: [],
      defaultParams: {
        //定义 练级选择器的国家和区域获取id
        label: "namec",
        value: "namec",
        children: "children",
      },
      countLIst: [],
      addType: false,
      search: "",
      currentSelectItem: {},
      changeType: null,
      form: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
    };
  },
  methods: {
    quxiao(){
      this.$parent.$parent.SonchangeShow(); //显示选择按钮
      this.addType = false
      this.showType = false
    },
    isPhone() {
      let mPattern = /^1[34578]\d{9}$/;
      return mPattern.test(this.form.tel);
    },
    setMome(item) {
      //设为默认
    },
    handleChange(value) {
      console.log(value);
      this.setLIstdata = value;
    },
    addbtn() {
      this.showType = false;
      this.addType = !this.addType;
      if(this.addType){
        this.$parent.$parent.SonchangeHide();
      }else{
        this.$parent.$parent.SonchangeShow();
      }
      
      this.getProvinces(); //获取提货省市区
    },
    back(Type) {
      if (Type == "I") {
        this.form.id = "";
      }
      if (this.form.name == "") return this.$message("请输入联系人姓名");
      if (this.form.tel == "") return this.$message("请输入联系人电话");
      if (!this.isPhone()) return this.$message("请输入正确的联系电话");
      if (this.form.setLIstdata == []) return this.$message("请选择省市区");
      if (this.form.address == "") return this.$message("请输入详细地址");
      let that = this;
      let params = {
        customerid: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        id: this.form.id,
        isdefault: false,
        name: this.form.name,
        tag: "",
        tel: this.form.tel,
        parvince: this.setLIstdata[0],
        city: this.setLIstdata[1],
        area: this.setLIstdata[2],
        address: this.form.address,
      };
      this.axios
        .post(`/customer/addOrUpdateDelivery`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.$parent.$parent.getPeopletable();
            this.$parent.$parent.SonchangeShow(); //显示选择按钮
            this.form.customerid = "";
            this.form.name = "";
            this.form.test = "";
            this.form.tel = "";
            this.form.city = "";
            this.form.address = "";
            this.form.id = "";
            this.area = "";
            this.parvince = "";
            this.setLIstdata = [];
            this.shouaddressid = [];
            this.showType = false;
            this.addType = false;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getCurrentRow(row) {
      console.log(row)
      this.$emit("func", row);
      localStorage.setItem("countLIst_T",JSON.stringify(row));
      this.$parent.$parent.hindDing();
      // this.currentSelectItem = item;
      // this.tableData.forEach((item) => {
      //   item.changeType != item.changeType;
      //   if (item.id !== row.id) {
      //     item.changeType = false;
      //   }
      //   if (item.changeType) {
      //     this.currentSelectItem = item;
      //   }
      // });
    },
    changesonItem() {
      this.$emit("func", this.currentSelectItem);
      console.log(this.currentSelectItem);
      localStorage.setItem("countLIst_T",JSON.stringify(this.currentSelectItem));
    },
    getProvinces() {
      //获取省市区
      let customerid = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .post(`/filedata/filedataProvinces`)
        .then((res) => {
          console.log(res);
          this.countLIst = res.data.datas;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleEdit(index, row) {
      //编辑
      this.$parent.$parent.SonchangeHide();
      this.showType = true;
      this.shouaddressid = [];
      console.log(row);
      this.addType = true;
      this.getProvinces();
      this.form.customerid = row.customerid;
      this.form.id = row.id;
      this.form.isdefault = row.isdefault;
      this.form.name = row.name;
      this.form.tag = row.tag;
      this.form.tel = row.tel;
      this.form.parvince = row.parvince;
      this.form.city = row.city;
      this.form.area = row.area;
      this.form.address = row.address;
      this.shouaddressid.push(row.parvince);
      this.shouaddressid.push(row.city);
      this.shouaddressid.push(row.area);
      this.setLIstdata = this.shouaddressid;
    },

    handleDelete(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                that.$parent.$parent.getPeopletable();
                this.$parent.$parent.SonchangeShow(); //显示选择按钮
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      // /customer/delAddress/{id}
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.coutn_show {
  width: 100%;
  float: left;
  box-sizing: border-box;
  border-radius: 8px;
}
.addcalss {
  color: #fff;
  background-color: #5f4aff;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  transition: 0.1s;
  font-weight: 500;
  float: right;
  font-size: 14px;
}
.add_wrap {
  border: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/airOrder/userArrdata.vue